<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Eventi-News/Eventi-News_top.jpg">
<div class="content">
    <h1>Eventi e News</h1>
</div>
</div>
<!-- <br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a class="active">Riserva naturale Valli Cupe</a></p>
</div>
<br> -->
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Sono tante le attività che rendono il soggiorno in Calabria particolarmente gradevole, 
            in ogni stagione. Si tratta di eventi culturali, religiosi, sportivi senza dimenticare le sagre e i festival dedicati alla ricca tradizione agroalimentare 
            di questa terra che evoca tutti i profumi e i sapori del Mediterraneo.
            <br>
            <br>
            In questa sezione vengono di volta in volta presentati gli appuntamenti più significativi sul territorio e anche informazioni relative ad attività 
            che riguardano la promozione turistica della regione con particolare riferimento ai Parchi e alle Riserve e ai 
            progetti di sviluppo turistico della Regione Calabria, come “<a href="https://calabriastraordinaria.it" target="_blank">Calabria straordinaria</a>”, “<a href="https://www.terradeipadricalabria.it" target="_blank">Calabria Terra dei Padri</a>”, la “<a href="https://www.ilcamminodisanfrancesco.it" target="_blank">Rete di San Francesco da Paola</a>” e 
            la “<a href="https://www.cicloviaparchicalabria.it/it/" target="_blank">Ciclovia dei Parchi della Calabria</a>”.
        </p>
    </div>
</div>
<br>
<br>
<div class="slider">
    <owl-carousel-o [options]="customOptions">
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Eventi-News/Evento_1-top.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">Il Natale in Calabria</h5>
                                <br>
                                <p class="museiText">
                                    Una festa molto sentita arricchita da tradizioni antichissime
                                    <br>
                                    <br>
                                    Il Natale in Calabria rievoca i riti religiosi e le tradizioni popolari legate alle previsioni e agli auspici per l’anno a venire. 
                                    In questo senso, molto sentito è il rito dell’accensione dei Falò di Natale (a seconda delle località detti anche fòcari, 
                                    Fuoco della Vigilia), un’usanza particolarmente viva e sentita. Si tratta dell’accensione di grandi pire di fuoco nei pressi 
                                    delle Chiede del paese dove si celebra la Messa di mezzanotte nella Vigilia di Natale, fuochi che sono alimentati per ardere 
                                    fino all’alba in segno di purificazione e rinascita, sancendo un passaggio simbolico dalle tenebre alla luce.
                                    <br>
                                    <br>
                                    Tra i tanti paesi in cui si possono apprezzare le fòcare di Natale, dal nord al sud della Calabria: in provincia di Cosenza a 
                                    Scigliano e Aiello Calabro e poi a Bocchigliero, dove il rito si tiene nella notte tra il 7 e l’8 dicembre in occasione della Festa 
                                    dell’Immacolata; in provincia di Catanzaro a Marcedusa, centro di etnia arbëreshë e Petronà. I fuochi si accendono anche nel centro di Crotone, 
                                    in occasione della festa di Santa Lucia nella notte tra il 12 e il 13 dicembre. Alla “magia della luce” è dedicata l’accensione di molti fuochi 
                                    e luminarie anche a Bova e nell’area grecanica.
                                </p>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Eventi-News/Evento_2-top.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">I TRENI DEL TORRONE</h5>
                                <br>
                                <p class="museiText">
                                    Un'occasione speciale per scoprire la storia di questo prodotto tipico della Calabria
                                    <br>
                                    <br>
                                    Nel periodo delle festività natalizie è possibile partecipare al tour guidato con trasferimenti dalla stazione di Bagnara Calabra in 
                                    cui i viaggiatori sono accompagnati alle fabbriche del torrone del Consorzio che ha costituito il marchio IGP "Torrone di Bagnara". 
                                    I partecipanti possono così assistere alle fasi della produzione, partecipare alla degustazione organizzata per l'occasione ed acquistare 
                                    il pregevole prodotto.  Il tour prevede anche la visita alle fabbriche della ceramica artistica in frazione Pellegrina e al 
                                    "Piccolo Museo del Borgo " a Porelli di Bagnara
                                    <br>
                                    <br>
                                    Il Torrone di Bagnara IGP è un dolce tipico della tradizione calabrese ottenuto dalla lavorazione di zucchero, mandorle tostate, 
                                    miele, albume d’uovo, cacao amaro, oli essenziali e spezie in polvere. A seconda della copertura, di zucchero in grani o di cacao amaro, 
                                    si distingue nelle due varietà Martiniana o Torrefatto glassato.
                                  
                                </p>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Eventi-News/Evento_3-top.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">I dolci della tradizione nel Pollino </h5>
                                <br>
                                <p class="museiText">
                                    Il Natale ha il sapore d’Oriente nei paesi di origine arberëshe
                                    <br>
                                    <br>
                                    Nei giorni delle festività legate al Natale è piacevolissimo trovarsi nei paesi di origini arberëshe che si trovano tra le province di Cosenza, 
                                    Catanzaro e Crotone, in particolare nel cuore del Parco nazionale del Pollino. In questi paesi, Civita, Lungro, 
                                    Santa Sofia d’Epiro, San Demetrio Corone, Carfizzi, Caraffa, ecc..., dove ancora sono vive le tradizioni di comunità 
                                    immigrate sin dal XV sec. che conservano lingua e costumi molto identitari, fervono i preparativi dei  tipici dolci natalizi, 
                                    vere e proprie delizie che rievocano sapori d’Oriente: le petullat o krispelet, sono morbide frittelle a forma di ciambella ottenute 
                                    con pasta lievitata e fritte in abbondante olio; i kanarikullat, una sorta di cannoli di pasta sfoglia impastata col vino, 
                                    fritti e poi cosparsi di miele; il xhurxhullet o xhurxhullinat, una specie di torrone ottenuto impastando miele, semi di sesamo e mandorle; 
                                    i bukunotet ripieni di marmellata, di mostarda o di ricotta; le kanaletet, a base di farina e uova e a forma di scaletta, spolverate con zucchero; 
                                    i krustulit, enormi gnocchi preparati come le kanallete, ma cosparsi di miele. Dolci dalla cui riuscita si traggono gli auspici per l’anno a venire.
                                </p>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Eventi-News/News_1-top.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">La Calabria dei Parchi Turismo sostenibile</h5>
                                <br>
                                <p class="museiText">
                                    Incontro di presentazione degli output del progetto “Calabria e Parchi”

                                    Il 26 novembre, presso il Centro Visita di Cupone, sul Lago Cecita, sono stati presentati alla stampa e al pubblico gli esiti dell’attività 
                                    di comunicazione inerente il progetto “Calabria e Parchi”, uno degli asset di sviluppo più significativi attuati dalla rete dei Parchi e 
                                    delle Riserve della Calabria per la valorizzazione delle Aree protette. 
                                    <br>
                                    <br>
                                    L’appuntamento si è aperto con la proiezione del video “Calabria: la nostra terra dei Parchi”, con la partecipazione di Emanuele Biggi, 
                                    regia di Palmarosa Fuccella e Francesco Vigliotti. All’incontro, organizzato dall’Ente Parco della Sila, hanno partecipato 
                                    i presidenti dei Parchi e i giornalisti coinvolti nel Press tour della Sila e dell’Area MaB: Alfredo Di Giovampaolo (RAI News-Cammina Italia), 
                                    Denis Falconieri (Lonely Planet), Angelo Melone (Repubblica), Vincenzo Petraglia (Dove-Bell’Italia), Elisa Gallo (BC-FIAB). Nell’occasione, 
                                    Giuseppe Zampino ha presentato le attività svolte dall’Agenzia nell’ambito del progetto, con particolare riferimento ai “Week end nei Parchi”, 
                                    rivolti agli studenti delle scuole calabresi, e al sito “Calabria e Parchi”.
                                </p>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Eventi-News/News_2-top.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">La Prima Festa della Ciclovia dei Parchi della Calabria</h5>
                                <br>
                                <p class="museiText">
                                    Un appuntamento partecipato per condividere gli esiti di un importante progetto di turismo sostenibile
                                    <br>
                                    <br>
                                    Al Teatro Politeama di Catanzaro, giovedì 14 dicembre, si è tenuta la prima festa della Ciclovia dei Parchi della Calabria a coronamento 
                                    di una stagione da incorniciare. L’infrastruttura turistica progettata dalla Regione Calabria con il concorso dei Parchi del Pollino, 
                                    della Sila, dell’Aspromonte e delle Serre, è ormai una delle destinazioni più apprezzate e desiderate non solo dai cicloturisti italiani 
                                    ma anche da quelli provenienti dall’Europa e, finanche, dagli Stati Uniti.
                                    <br>
                                    <br>
                                    La Festa della Ciclovia dei Parchi è stata una proficua occasione di incontro per parlare di cicloturismo, di sicurezza e di mobilità 
                                    sostenibile insieme alle istituzioni coinvolte e ai graditi ospiti dell’evento: Davide Cassani, ex CT della Nazionale Italiana Ciclismo, 
                                    Antonio Dalla Venezia di Bicitalia, Daniele Carletti e Simona Pergola che hanno viaggiato sulla Ciclovia per primi nel 2020 dopo aver 
                                    girato il mondo, i triatleti Alessandra Fior e Luca Mancuso che in ottobre hanno completato il loro percorso da Laino Borgo a Reggio Calabria.
                                     Ha condotto il talk Marco Innocente Furina, giornalista RAI. Aperta dall’intervento dei presidenti dei Parchi e dalla testimonianza di operatori
                                      turistici che hanno aderito alla Carta dei servizi della Ciclovia dei Parchi, la festa si è conclusa con il concerto “Musico Ambulante Tour” 
                                      di Fabio Concato che ha proposto al pubblico presente i suoi grandi successi, tra note e parole. 

                                </p>
                    </div>
                </div>
            </div>
        </ng-template>  
        <ng-template carouselSlide>
            <div class="card museiCard">
                <img class="card-img-top" src="../../../assets/images/Eventi-News/News_3-top.jpg" alt="Card image cap">
                <div class="card-body">
                    <div class="card-content">
                                <h5 class="museiTitleCard">Il Parco Nazionale del Pollino compie trent’anni</h5>
                                <br>
                                <p class="museiText">
                                    In programma una serie di iniziative per celebrare l’istituzione della più vasta area protetta d’Europa
                                    <br>
                                    <br>
                                    Il Pollino, con i suoi centottantamila ettari di estensione e con più di centosettantamila abitanti è il più vasto e articolato 
                                    Parco nazionale d'Europa. Nel 2015 il Parco è entrato a far parte della Rete europea e globale dei Geoparchi sotto l’egida dell’UNESCO che, 
                                    rispettivamente nel 2017 e nel 2021, ha inserito la Faggeta Vetusta di Cozzo Ferriero e la Faggeta Vetusta del Pollinello nel Sito transnazionale 
                                    delle “Antiche Faggete Primordiali dei Carpazi e di altre regioni d’Europa”, proclamandole Patrimonio Mondiale. 
                                    <br>
                                    <br>
                                    A trent’anni dalla sua istituzione l’Ente ha programmato una serie di incontri e iniziative che si sono tenute sia sul versante 
                                    lucano che in quello calabrese. Di particolare rilevanza la mostra fotografica a cura di Bruno Niola con il reportage di Pierluigi Rottura e 
                                    Francesco Vigliotti che presenta il paesaggio naturale nelle diverse stagioni, il paesaggio antropico e le attività di conservazione e 
                                    tutela svolte negli anni dal Parco.
                                    <br>
                                    <br>
                                    La mostra, dopo il primo allestimento dell’Ecomuseo di Rotonda (PZ), nella sede del Parco di Santa Maria della Consolazione, 
                                    è stata presentata anche presso la Società Geografica Italiana di Roma (4-5 dicembre) e poi negli spazi della Catasta, 
                                    l’hub turistico del Parco in località Campotenese, dove sarà visitabile fino alla fine di gennaio 2024. 
                                    Le immagini sono confluite nell’elegante pubblicazione curata dall’Ente Parco. 
                                </p>
                    </div>
                </div>
            </div>
        </ng-template>  
 
      </owl-carousel-o>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>